import React from 'react';
import { DataGrid } from '@mui/x-data-grid';

const DataTablePagination = ({
  rows,
  columns,
  rowCount,
  page,             // number, 0-based
  setPage,          // function
  pageSize,         // number
  setPageSize,      // function
  localeTextsMap,
  // Optional row-height controls — defaults keep the current behavior.
  getRowHeight,
  getEstimatedRowHeight,
  rowHeight,
}) => {
  // MUI approach: define an object with page/pageSize
  const paginationModel = {
    page: page,
    pageSize: pageSize,
  };

  // Called whenever user clicks next/prev or changes pageSize
  const handlePaginationModelChange = (model) => {
    if (model.page !== page) {
      setPage(model.page);
    }
    if (model.pageSize !== pageSize) {
      setPageSize(model.pageSize);
    }
  };

  return (
    <DataGrid
      autoHeight
      rows={rows}
      columns={columns.filter(Boolean)}
      rowCount={rowCount}
      pagination
      paginationMode="server"
      paginationModel={paginationModel}
      onPaginationModelChange={handlePaginationModelChange}

      // set which pageSize values to allow
      pageSizeOptions={[5, 10, 25, 50,75, 100]}

      {...(getRowHeight ? { getRowHeight } : {})}
      {...(getEstimatedRowHeight ? { getEstimatedRowHeight } : {})}
      {...(rowHeight ? { rowHeight } : {})}

      localeText={localeTextsMap}
      style={{ overflowX: 'auto' }}
      slotProps={{
        scrollbarContainer: {
          'aria-hidden': false,
          tabIndex: 0,
        },
      }}

      sx={{
        fontSize: '0.875rem',
        '& .MuiDataGrid-columnHeaders': {
          backgroundColor: '#f8f9fa',
          color: 'var(--brand-red)',
          fontWeight: 600,
          fontSize: '0.9rem',
        },
        '& .MuiDataGrid-cell': {
          fontSize: '0.85rem',
        },
        '& .MuiDataGrid-footerContainer': {
          fontSize: '0.85rem',
        },
        '& .MuiTablePagination-selectLabel': {
          fontSize: '0.85rem',
        },
        '& .MuiTablePagination-displayedRows': {
          fontSize: '0.85rem',
        },
        '.tableHeaderClassName': { fontWeight: 600 },
        '.tableCellClassName': { padding: '8px' }
      }}
    />
  );
};

export default DataTablePagination;
